























































































































































































import { defineComponent, toRefs, onMounted, reactive, ref } from '@vue/composition-api';
import VerifyCode from '@components/VerifyCode/index.vue';
import PwdInput from '@components/PwdInput/index.vue';
import TCaptcha from '@components/TCaptcha/index.vue';
import DealAndPolicyDialog from '@components/dealAndPolicyDialog/index.vue';
import { verifyMsg, verificaPassword, verificaCode, confirmPassword, verificaPsw } from '@/useable/verification';
import { useLogin } from '@/useable/login';
import request from '@utils/request';
import { Message } from 'element-ui';
import md5 from 'js-md5';
import _Const from '@/Const';

export default defineComponent({
  name: 'Register',
  components: {
    VerifyCode,
    PwdInput,
    TCaptcha,
    DealAndPolicyDialog
  },
  setup(prop: any, { root }) {
    const { inviteMsg, supplierId, supplierCertId, bankCode, type } = root.$route.query;
    /**
     * 1.有bankcode -- 全部可修改；
     * 2.type=reg -- 只有社会信用代码不可修改；
     * 3.type=invitationReq -- 前五项不可修改；
     * 4.inviteMsg和supplierId都存在时，会调接口/showRegistersByCode，如果返回code2009，表示邀请过期或无效 -- 前五项不可修改；
     * */
    const isCustomer = ref(!!bankCode);
    const isOut = ref(false); // 邀请是否过期
    const loading = ref(false);
    const dialogRegisteVisible = ref(false); // 点注册按钮显示弹框
    const dialogReadTitle = ''; // 弹框协议标题
    const dialogReadType = ''; // 协议类别
    const state: any = reactive({
      action: `${process.env.VUE_APP_API_URL}v1/api/suppRegisterFileUpload`, // 文件上传接口地址
      updataObj: {
        fileType: 'AUTH'
      },
      authDialogImageUrl: '', // 授权函图片预览地址
      licenseDialogImageUrl: '', // 执照图片预览地址
      authUploadVisible: false, // 显示授权函图片
      licenseUploadVisible: false, // 显示执照图片
      authName: '', // 授权函文件名
      licenseName: '', // 执照图片文件名
    });
    const authfileTotal = ref(0); // 授权函文件数量
    const licensefileTotal = ref(0); // 执照文件数量

    const dialogVisible = ref(false); // 显示接口返回提示弹框
    const dealVisible = ref(false); // 显示协议
    const hideForm = ref<any>(false);
    const multiCompany = ref<any>(false); // 是否绑定多家公司
    const checked = ref(false); // 是否勾选同意协议
    const dialogMsg = ref(''); // 提示内容
    const dialogType = ref(false); // 是否点击提示框确定跳转到登录页
    const companyInfor = reactive({
      name: null,
      workEmail: '',
      cellPhone: null,
      password: '',
      confirmPassword: '',
      checkCode: null,
      isRegister: false,
      supplierId,
      supplierName: null,
      supplierCertId,
      isCore: false
      // companyList: [] as any[],
      // selectCompany: {
      //   supplierId: '',
      //   supplierName: ''
      // }
    });

    // const getCompanyList = async () => {
    //   const res = await request('login', 'queryUserJoinInfo', {
    //     workEmail: companyInfor.workEmail,
    //   }) as Api.ResponseData;

    //   if ( res.code === 2007) {
    //     Message.error(res.message);
    //     return;
    //   }

    //   if (res.code === 2000) {
    //     companyInfor.companyList = res.data.companyList;
    //     multiCompany.value = res.data.companyList.length > 1;
    //     const selectItem = res.data.companyList.find((item: { supplierId: string | (string | null)[]; }) => item.supplierId === supplierId);
    //     Object.assign(companyInfor.selectCompany, { supplierId:selectItem.supplierId, supplierName: selectItem.supplierName });
    //     companyInfor.supplierName = computed(() => companyInfor.selectCompany.supplierName).value;
    //     companyInfor.supplierId = computed(() => companyInfor.selectCompany.supplierId).value;
    //   }
    // };

    // 获取公司信息
    const getCompanyInfor = async () => {
      loading.value = true;
      const res = await request('login', 'showRegistersByCode', { inviteMsg, supplierId, type });
      if (res.code === 2000) {
        companyInfor.supplierName = res.data.supplierName;
        companyInfor.supplierCertId = res.data.supplierCertId;
        companyInfor.name = res.data.name;
        companyInfor.workEmail = res.data.workEmail;
        companyInfor.cellPhone = Number(res.data.cellPhone) as any;
        companyInfor.isRegister = res.data.registerStatus === 1;
        companyInfor.isCore = res.data.companyType === 0;
        // if (res.data.registerStatus === 1){
        //   await getCompanyList();
        // }
        loading.value = false;
      } else if (res.code === 2009) {
        isOut.value = true;
        loading.value = false;
      } else {
        loading.value = false;
      }
    };

    onMounted(() => {
      if (bankCode && _Const.ReadyBankCode.indexOf(bankCode as any) < 0) {
        Message.error('链接有误，请检查参数是否正确');
        isCustomer.value = false;
        return;
      }
      if (inviteMsg && supplierId) {
        getCompanyInfor();
      }
    });

    // 操作提示的确认按钮
    const confirmBtn = () => {
      dialogVisible.value = false;
      if (dialogType.value) {
        dialogType.value = false;
        root.$router.push({
          name: 'Login',
          params: { workEmail: companyInfor.workEmail }
        });
      }
    };

    // 注册按钮-校验部分
    const register = async () => {
      if (!verificaPsw(companyInfor.password)) {
        Message.error('密码应该为大小写字母、数字组合或特殊字符任意三种，8至位15位！');
        return;
      }
      if (!companyInfor.isRegister && !confirmPassword(companyInfor.password, companyInfor.confirmPassword)) {
        Message.error('两次输入的密码不一致');
        return;
      }
      if (!companyInfor.supplierCertId) {
        Message.error('请输入企业统一社会信用代码');
        return;
      }
      if (!companyInfor.supplierName) {
        Message.error('请输入企业名称');
        return;
      }
      if (!companyInfor.name) {
        Message.error('请输入姓名');
        return;
      }
      if (!companyInfor.workEmail) {
        Message.error('请输入注册邮箱');
        return;
      }
      if (!companyInfor.cellPhone) {
        Message.error('请输入绑定手机号');
        return;
      }
      if (!state.authName && !companyInfor.isCore) {
        Message.error('请上传授权函');
        return;
      }

      if (!state.licenseName && !companyInfor.isCore) {
        Message.error('请上传营业执照');
        return;
      }

      if (!companyInfor.checkCode) {
        Message.error('请输入验证码');
        return;
      }

      if (!checked.value) {
        Message.error('请先阅读并同意用户协议和隐私政策');
        return;
      }

      if (!companyInfor.isCore) {
        dialogRegisteVisible.value = true;
        return;
      }
      onRegister();
    };

    // 调用注册接口
    const onRegister = async () => {
      const res = await request('login', 'register', {
        name: companyInfor.name,
        cellPhone: companyInfor.cellPhone,
        supplierName: companyInfor.supplierName,
        workEmail: companyInfor.workEmail,
        password: md5(companyInfor.password),
        checkCode: companyInfor.checkCode,
        supplierCertId: companyInfor.supplierCertId,
        supplierId,
        bankCode
      });

      if (res.code === 2000) {
        if (companyInfor.isRegister && companyInfor.isCore) {
          login();
        } else {
          if (bankCode) {
            dialogType.value = true;
            dialogMsg.value = '您的账号已成功注册，注册后产生的新账单将同步到平台，历史账单暂不可查。如需进行融资申请，请提前与平台合作银行签约开通供应链融资服务。开通银行服务后，平台将于次日同步银行签约信息。';
            dialogVisible.value = true;
          } else {
            Message.success('注册成功');
            root.$router.push({
              name: 'Login',
              params: { workEmail: companyInfor.workEmail }
            });
          }
        }

      } else if (res.code === 3653) {
        dialogMsg.value = `${res.message}`;
        dialogVisible.value = true;
      } else if (res.code === 3654) {
        dialogMsg.value = `${res.message}`;
        dialogVisible.value = true;
      } else if (res.code === 7060) {
        dialogMsg.value = `${res.message}`;
        dialogVisible.value = true;
      } else if (res.code === 3655) {
        dialogMsg.value = `${res.message}`;
        dialogVisible.value = true;
      }
    };

    const imageCheckParams = reactive({
      randStr: '',
      ticket: '',
    });

    // 图片校验函数
    const imageCheck = async () => {
      const res = await request('login', 'imageCheck', imageCheckParams);
      if (res.code === 2000) {
        await register();
        // await useLogin(companyInfor);
      }
    };

    const captchaObj = reactive({
      show: false,
      destroy: false,
      captchaId: 'TecentCaptcha',
      pass: false,
      handlerCaptcha: async (data: any) => {
        if (data.ret === 0) {
          captchaObj.destroy = true;
          captchaObj.pass = true;
          captchaObj.show = false;
          imageCheckParams.randStr = data.randstr;
          imageCheckParams.ticket = data.ticket;
          if (!multiCompany.value) {
            await imageCheck();
            // await useLogin(form);
          } else {
            hideForm.value = true;
          }
        }
      },
    });

    // 调用登录接口
    const login = async () => {
      console.log('login');
      if (!companyInfor.supplierId) {
        Message.error('请先选择登录企业');
        return;
      }
      await useLogin(companyInfor);
    };

    const processFunc = () => {
      const result = verificaPassword(companyInfor.password) && verificaCode(companyInfor.checkCode);
      if (result) {
        console.log('process');
        captchaObj.show = true;
      } else {
        captchaObj.show = false;
        Message.error(verifyMsg.value);
      }
    };

    /** 文件上传前的钩子 */
    const authBeforeAvatarUpload = (file: any) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (isLt10M) {
        authfileTotal.value = 1;
      } else {
        Message.error('上传文件大小不能超过 10MB!');
        return false;
      }
    };
    /** 文件上传前的钩子 */
    const licenseBeforeAvatarUpload = (file: any) => {
      console.log(file);
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (isLt10M) {
        licensefileTotal.value = 1;
      } else {
        Message.error('上传文件大小不能超过 10MB!');
        return false;
      }

    };
    /** 文件上传成功的钩子 */
    const authHandleAvatarSuccess = (res: any) => {
      console.log('>>>>>>>>>>>>上传成功');
      if (res.code === 2000 && res.data) {
        Message.success('上传成功');
        state.authName = res.data.fileName;
      } else {
        Message.error(res.message);
      }
    };
    /** 文件上传成功的钩子 */
    const licenseHandleAvatarSuccess = (res: any) => {
      console.log('>>>>>>>>>>>>上传成功');
      if (res.code === 2000 && res.data) {
        Message.success('上传成功');
        state.licenseName = res.data.fileName;
      } else {
        Message.error(res.message);
      }
    };
    /** 文件上传失败的钩子 */
    const handleError = (res: any) => {
      console.log(res);
    };
    /** 文件列表移除文件时的钩子 */
    const authHandleRemove = (file: any, fileList: any, params) => {
      console.log('params', params);
      authfileTotal.value = 0;
      state.authName = '';
    };
    /** 文件列表移除文件时的钩子 */
    const licenseHandleRemove = (file: any, fileList: any, params) => {
      console.log('params', params);
      licensefileTotal.value = 0;
      state.licenseName = '';
    };

    /** 点击文件列表中已上传的文件时的钩子 */
    const authHandlePreview = (file: any) => {
      console.log('file123', file);
      state.authDialogImageUrl = file.url;
      state.authUploadVisible = true;
    };
    /** 点击文件列表中已上传的文件时的钩子 */
    const licenseHandlePreview = (file: any) => {
      console.log('file123', file);
      state.licenseDialogImageUrl = file.url;
      state.licenseUploadVisible = true;
    };

    // 模板下载
    const onDownload = async () => {
      await request('login', 'downLoadModel');
    };

    // 上传前校验信息完整
    const isActive = () => {
      if (!companyInfor.supplierCertId || !companyInfor.workEmail) {
        Message.error('请先填写企业统一社会信用代码及注册邮箱，再进行文件上传。');
      }
    };

    // 修改信用代码或邮箱时清空上传的文件
    const clearFile = () => {
      state.authName = '';
      state.licenseName = '';
    };

    return {
      ...toRefs(state),
      isOut,
      companyInfor,
      hideForm,
      multiCompany,
      captchaObj,
      getCompanyInfor,
      register,
      login,
      processFunc,
      loading,
      checked,
      isCustomer,
      dialogVisible,
      dialogMsg,
      confirmBtn,
      dealVisible,
      authBeforeAvatarUpload,
      licenseBeforeAvatarUpload,
      authHandleAvatarSuccess,
      licenseHandleAvatarSuccess,
      handleError,
      authHandleRemove,
      licenseHandleRemove,
      authHandlePreview,
      licenseHandlePreview,
      authfileTotal,
      licensefileTotal,
      onDownload,
      dialogReadTitle,
      dialogReadType,
      dialogRegisteVisible,
      onRegister,
      type,
      isActive,
      clearFile
    };
  },
});
